export enum ProductType {
    Requisition = 0,
    AIDocumentInsightsPackage = 1,
    OCRPackage = 2,
    WalletTopUp = 100,
    Other = 9999
}

export class ProductInfoModel {
    productType?: ProductType|string;
    productId?: string;
}
